import apiActions from 'app/utils/apiActions';

const narrativeActions = {
  // startDate / endDate are 'YYYY-MM-DD' strings
  async generate(startDate, endDate, useClaude = false) {
    return await apiActions.request('narratives/generate', 'POST', {
      start_date: startDate,
      end_date: endDate,
      use_claude: useClaude,
    });
  },

  // Narrative for a single value's history. Pass feedback + previousNarrative
  // to ask for a revision of an earlier pass.
  async generateForValue(valueId, useClaude = false, feedback = null, previousNarrative = null) {
    return await apiActions.request('narratives/generate', 'POST', {
      value_id: valueId,
      use_claude: useClaude,
      feedback,
      previous_narrative: previousNarrative,
    });
  },
};

export default narrativeActions;
